import classNames from 'classnames';
import React, { useState } from 'react';

interface IProps {
  variant?:
    | 'primary'
    | 'secondary'
    | 'rounded'
    | 'outline'
    | 'rounded-outline'
    | 'rounded-full'
    | 'light'
    | 'rounded-sm'
    | 'outline-sm'
    | 'outline-primary'
    | 'outline-disabled';
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset' | undefined;
  isDisabled?: boolean;
}

const CustomButton = ({ variant = 'primary', children, className, type, onClick, isDisabled }: IProps) => {
  const [isClicked, setIsClicked] = useState<boolean>(false);
  return (
    <button
      className={classNames('text-base font-istok-web text-nowrap', className, {
        'bg-navy-blue text-white': variant === 'primary',
        'bg-transparent text-navy-blue': variant === 'secondary',
        'rounded-lg text-white bg-navy-blue py-2.5 px-8': variant === 'rounded',
        'rounded-full text-white bg-navy-blue': variant === 'rounded-full',
        'bg-transparent border border-navy-blue text-navy-blue': variant === 'outline',
        'bg-transparent border border-navy-blue rounded-[10px] text-white': variant === 'rounded-outline',
        'border-2 border-navy-blue rounded-[10px] text-navy-blue px-2.5 2xl:px-5 py-1.5 text-lg font-bold tracking-[3.06px] leading-normal hover:shadow-outline-button-shadow hover:border-pale-yellow':
          variant === 'outline-primary',
        'border border-navy-blue rounded-[10px] text-lg text-navy-blue font-bold min-w-[122px] h-[35px]':
          variant === 'outline-sm',
        'btn-transition': isClicked,
        'bg-silverstone': isDisabled && variant !== 'outline-disabled',
        '!border-2 !border-[#B3B4B4] !bg-bg-trans-white !rounded-[10px] text-[#B3B4B4] px-2.5 2xl:px-5 py-1.5 text-lg font-bold tracking-[3.06px] leading-normal cursor-not-allowed':
          variant === 'outline-disabled'
      })}
      type={type}
      onClick={() => {
        setIsClicked(true);
        onClick && onClick();
      }}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
};

export default CustomButton;
